import { useEffect, useRef, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";

import MainFooter from "../components/MainFooter";

import upcomingEventIcon from "../ui-assets/home/upcoming-event-icon.svg";
import eventShareIcon from "../ui-assets/home/share.svg";
import eventBackcardIcon from "../ui-assets/home/event-back-date-icon.svg";

import "../styles/NewHome.css";
import { API_BASE_URL } from "../config";
import { toast } from "react-toastify";

const ShareModal = ({ eventId, onClose }) => {
  const [copied, setCopied] = useState(false);

  const baseUrl = window.location.origin;
  const eventLink = `${baseUrl}/eventpage/${eventId}`;

  const handleCopy = () => {
    navigator.clipboard.writeText(eventLink).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2500);
    });
  };

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div className="pshare-modal-overlay" onClick={handleBackdropClick}>
      <div className="share-modal">
        <div className="share-modal-header">
          <h5 className="share-modal-title">Share event link</h5>
          <button
            className="share-modal-close"
            onClick={onClose}
            aria-label="Close"
          >
            &times;
          </button>
        </div>
        <div className="share-modal-body">
          <div className="share-modal-input-row">
            <input
              type="text"
              className="share-modal-input"
              value={eventLink}
              readOnly
            />
            <button
              className={`share-modal-copy-btn${copied ? " copied" : ""}`}
              onClick={handleCopy}
            >
              {copied ? "Copied!" : "Copy"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

const FilterDropdown = ({ label, options, selected, onSelect, onClear }) => {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const handler = (e) => {
      if (ref.current && !ref.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  const isActive = !!selected;

  return (
    <div className="ae-filter-dropdown" ref={ref}>
      <button
        className={`ae-filter-pill${isActive ? " ae-filter-pill--active" : ""}`}
        onClick={() => setOpen((prev) => !prev)}
      >
  
{label === "Filter by City" ? (
  <i className="fa-solid fa-location-dot ae-filter-icon" />
) : (
  <i className="fa-regular fa-calendar-days ae-filter-icon" />
)}

<span className="ae-filter-pill__text">
  {isActive ? selected : label}
</span>

{isActive ? (
  <span
    className="ae-filter-pill__clear"
    onClick={(e) => {
      e.stopPropagation();
      onClear();
      setOpen(false);
    }}
  >
    <i className="fa-solid fa-xmark" />
  </span>
) : (
  <span
    className={`ae-filter-pill__arrow ${
      open ? "ae-filter-pill__arrow--up" : ""
    }`}
  >
    <i className="fa-solid fa-angle-down" />
  </span>
)}

      </button>

      {open && (
        <ul className="ae-filter-menu">
          {options.length === 0 && (
            <li className="ae-filter-menu__item ae-filter-menu__item--empty">
              Loading…
            </li>
          )}
          {options.map((opt) => (
            <li
              key={opt}
              className={`ae-filter-menu__item${selected === opt ? " ae-filter-menu__item--selected" : ""}`}
              onClick={() => {
                onSelect(opt);
                setOpen(false);
              }}
            >
              {opt}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};


const AllEvent = () => {
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [totalPages, setTotalPages] = useState(1);
  const [shareEventId, setShareEventId] = useState(null);
  const [cityOptions, setCityOptions] = useState([]);
  const [typeOptions, setTypeOptions] = useState([]);
  const navigate = useNavigate();

  const [searchParams, setSearchParams] = useSearchParams();
  const page = Number(searchParams.get("page")) || 1;
  const selectedCity = searchParams.get("city") || "";
  const selectedType = searchParams.get("event_type") || "";

  useEffect(() => {
    const token = localStorage.getItem("token");

    fetch(`${API_BASE_URL}/events?page=1&npp=70`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    })
      .then((res) => res.json())
      .then((data) => {
        const results = data?.result || [];

        const cities = [
          ...new Set(results.map((e) => e?.metadata?.city).filter(Boolean)),
        ].sort();

        const types = [
          ...new Set(
            results.map((e) => e?.metadata?.event_type).filter(Boolean),
          ),
        ].sort();

        setCityOptions(cities);
        setTypeOptions(types);
      })
      .catch((err) => console.error("Filter options fetch error ❌", err));
  }, []);

  useEffect(() => {
    const token = localStorage.getItem("token");
    setLoading(true);

    const params = new URLSearchParams({
      page,
      npp: 15,
    });
    if (selectedCity) params.append("city", selectedCity);
    if (selectedType) params.append("event_type", selectedType);

    fetch(`${API_BASE_URL}/events?${params.toString()}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    })
      .then((res) => res.json())
      .then((data) => {
        console.log("ALL EVENTS API 👉", data);
        setEvents(data?.result || []);
        setTotalPages(data?.total_pages || 1);
      })
      .catch((err) => {
        console.error("API Error ❌", err);
        setEvents([]);
      })
      .finally(() => setLoading(false));
  }, [page, selectedCity, selectedType]);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [page]);

  const applyFilter = (key, value) => {
    const next = new URLSearchParams(searchParams);
    next.set(key, value);
    next.set("page", "1");
    setSearchParams(next);
  };

  const clearFilter = (key) => {
    const next = new URLSearchParams(searchParams);
    next.delete(key);
    next.set("page", "1");
    setSearchParams(next);
  };

  // ✅ Updated handleRegister with registration check
  const handleRegister = (event) => {


    if (
    event?.metadata?.status?.toUpperCase() === "CLOSED" ||
    event?.metadata?.status?.toUpperCase() === "CLOSE"
  ) {
    toast.info("This event has been closed.");
    return;
  }

    if (!event?.metadata?.isAttendeeRegistrationOpen) {
      toast.info(
        event?.metadata?.attendeeRegistrationMsg || "Registration is currently closed"
      );
      return;
    }

    const eventId = event?.metadata?.event_id;
    navigate(`/free-event-register/event/${eventId}`);
  };

  
const handleEventPage = (event) => {
  const eventId = event?.metadata?.event_id;

  if (eventId) {
    window.open(
      `/eventpage/${eventId}`,
      "_blank",
      "noopener,noreferrer"
    );
  } else {
    toast.error("Event ID not found");
  }
};

  const handleShareClick = (e, event) => {
    e.stopPropagation();
    setShareEventId(event?.metadata?.event_id);
  };

  const formatEventDate = (start, end) => {
    if (!start || !end) return "";

    const startDate = new Date(start);
    const endDate = new Date(end);

    const sameMonth = startDate.getMonth() === endDate.getMonth();
    const sameYear = startDate.getFullYear() === endDate.getFullYear();

    const startStr = startDate.toLocaleDateString("en-US", {
      month: "short",
      day: "numeric",
    });

    const endStr = endDate.toLocaleDateString("en-US", {
      month: sameMonth ? undefined : "short",
      day: "numeric",
      year: sameYear ? undefined : "numeric",
    });

    const yearStr = startDate.getFullYear();

    return `${startStr}–${endStr}, ${yearStr}`;
  };

  return (
    <div className="all-events-page">
      <section className="container upcoming-event-wrapper">

        
<div className="events-header-box">
  <div className="events-heading">
    <span className="events-heading-accent"></span>

    <h2>
      All <span>Events</span>
    </h2>
  </div>

  <div className="ae-filter-bar">
    <FilterDropdown
      label="Filter by City"
      options={cityOptions}
      selected={selectedCity}
      onSelect={(val) => applyFilter("city", val)}
      onClear={() => clearFilter("city")}
    />

    <FilterDropdown
      label="Event Type"
      options={typeOptions}
      selected={selectedType}
      onSelect={(val) => applyFilter("event_type", val)}
      onClear={() => clearFilter("event_type")}
    />
  </div>
</div>


        {loading ? (
          <div style={{ textAlign: "center", padding: "30px 0" }}>
            Loading events...
          </div>
        ) : events.length === 0 ? (
          <div style={{ textAlign: "center", padding: "30px 0" }}>
            No events found...
          </div>
        ) : (
          <div className="product-grid">
            {events.map((event) => {
              // ✅ Console logs for debugging
              console.log("ALL EVENTS ITEM =>", event);
              console.log("ALL EVENTS METADATA =>", event.metadata);
              console.log("isAttendeeRegistrationOpen =>", event?.metadata?.isAttendeeRegistrationOpen);
              console.log("attendeeRegistrationMsg =>", event?.metadata?.attendeeRegistrationMsg);

              return (
                <div className="product-item" key={event.id}>
                  <div
                    className="flip-card"
                    onClick={() => handleEventPage(event)}
                  >
                    <div className="flip-card-inner">
                      {/* BACK */}
                      <div className="flip-card-back">
                        <div className="card-img-wrap">
                          {event?.banner_file?.base64 ? (
                            <img
                              src={event.banner_file.base64}
                              alt={event?.metadata?.name}
                            />
                          ) : (
                            <div className="card-img-placeholder">
                              <i className="fas fa-calendar-alt"></i>
                            </div>
                          )}

                          {event?.metadata?.event_type && (
                            <span className="card-event-type-badge">
                              {event.metadata.event_type}
                            </span>
                          )}
                        </div>

                        <div className="card-content">
                          <div className="card-meta-pills">
                            <span className="card-date-pill">
                              <img src={eventBackcardIcon} alt="" width="12" />
                              {formatEventDate(
                                event?.metadata?.start_date,
                                event?.metadata?.end_date
                              )}
                            </span>

                            <span className="card-city-pill">
                              {event?.metadata?.city}
                            </span>
                          </div>

                          <h4 className="card-title">
                            {event?.metadata?.name}
                          </h4>

                          {event?.metadata?.description && (
                            <p className="card-desc">
                              {event.metadata.description}
                            </p>
                          )}

                          {/* ✅ Updated button with registration open/close logic */}
                         <button
  className={`card-register-btn ${
    event?.metadata?.status?.toUpperCase() === "CLOSED" ||
    event?.metadata?.status?.toUpperCase() === "CLOSE"
      ? "disabled-btn"
      : !event?.metadata?.isAttendeeRegistrationOpen
      ? "disabled-btn"
      : ""
  }`}
  onClick={(e) => {
    e.stopPropagation();

    // Don't allow click if event is closed
    if (
      event?.metadata?.status?.toUpperCase() === "CLOSED" ||
      event?.metadata?.status?.toUpperCase() === "CLOSE"
    ) {
      return;
    }

    handleRegister(event);
  }}
>
  {event?.metadata?.status?.toUpperCase() === "CLOSED" ||
  event?.metadata?.status?.toUpperCase() === "CLOSE"
    ? "Event Closed"
    : event?.metadata?.isAttendeeRegistrationOpen
    ? "Register Event"
    : "Registration Closed"}
</button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        )}

        <div className="number-pagination">
          {[...Array(totalPages)].map((_, i) => {
            const pageNumber = i + 1;
            const isActive = page === pageNumber;

            return (
              <button
                key={pageNumber}
                disabled={isActive}
                className={isActive ? "active" : ""}
                onClick={() => {
                  if (!isActive) {
                    const next = new URLSearchParams(searchParams);
                    next.set("page", pageNumber);
                    setSearchParams(next);
                  }
                }}
              >
                {pageNumber}
              </button>
            );
          })}
        </div>
      </section>

      {shareEventId && (
        <ShareModal
          eventId={shareEventId}
          onClose={() => setShareEventId(null)}
        />
      )}

      <MainFooter />
    </div>
  );
};

export default AllEvent;